import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3afb5e82")

_pushScopeId("data-v-3afb5e82")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Leaderboard")
const _hoisted_2 = { class: "px-16 fill df-col flex-1" }
const _hoisted_3 = {
  class: "f-md my-16",
  style: {"line-height":"20px"}
}
const _hoisted_4 = { class: "bg-white df-col flex-1 mb-32" }
const _hoisted_5 = { class: "i-table df-col my-16 flex-1 pb-32" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_TheDateSelect = _resolveComponent("TheDateSelect")
  const _component_RankItem = _resolveComponent("RankItem")
  const _component_List = _resolveComponent("List")
  const _component_Holder = _resolveComponent("Holder")
  const _component_Scroller = _resolveComponent("Scroller")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "home_39" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    body: _withId(() => [
      _createVNode(_component_Scroller, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_t, {
                as: "div",
                path: "leaderboard_2",
                multiline: "",
                custom: ""
              }, {
                default: _withId(({td}) => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(td, (p, index) => {
                    return (_openBlock(), _createBlock("p", {
                      class: "mb-4",
                      key: index
                    }, _toDisplayString(p), 1))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_TheDateSelect, { onChange: _ctx.dateChange }, null, 8, ["onChange"]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Holder, {
                  content: _ctx.listData,
                  "skeleton-repeat": 1,
                  "holder-class": "px-16"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_List, {
                      "list-data": _ctx.listData,
                      "pull-refresh": "",
                      onRefresh: _ctx.refresh
                    }, {
                      default: _withId(({ item }) => [
                        _createVNode(_component_RankItem, { item: item }, null, 8, ["item"])
                      ]),
                      _: 1
                    }, 8, ["list-data", "onRefresh"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})